<div class="search-popup">

  <pl-text name="name" id="name" title="Search" [(ngModel)]="searchText" [show_title]="false"
    (keydown)="onKeyDown($event)" autofocus (input)="onSearch()">
  </pl-text>

</div>



<div class="tags-container">

  <div *ngFor="let menu of filteredMenus; let i = index" class="tag" [class.active]="i === selectedIndex" (click)="Click(menu)">
    {{ menu.name }}
  </div>

</div>